<template>
  <div>
    <select2
      :required="!atLeastSectorSelected"
      :options="options"
      v-model="selected"
      placeholder="Capital Type"
      parent="capital"
    >
    </select2>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Select2 from "./Select2Wrapper.vue";

export default {
  name: "CapitalTypeDropDown",
  components: {
    select2: Select2
  },
  data: function() {
    return {
      selected: ""
    };
  },
  computed: {
    ...mapGetters([
      "selectedDropdownCapitalType",
      "capitalTypes",
      "selectedDropdownSector",
      "fundingNeed"
    ]),
    atLeastSectorSelected() {
      return this.selectedDropdownSector != undefined;
    },
    options: function() {
      var opt = [
        {
          id: 0,
          text: "All"
        }
      ];
      opt.push(
        ...this.capitalTypes.map((capType, i) => {
          return {
            id: capType.code,
            text: capType.name == "Lending" ? "Debt" : capType.name
          };
        })
      );
      return opt;
    }
  },
  methods: {
    ...mapMutations({
      setCapitalType: "setCapitalTypesParam",
      setDropdownCapitalType: "setDropdownCapitalType"
    })
  },
  watch: {
    selected: function(value) {
      if (value == "0") {
        this.setCapitalType();
      } else if (value != null) {
        var capitalType = this.capitalTypes.filter(
          item => item.code == value
        )[0];
        this.setCapitalType(capitalType);
      }
      this.setDropdownCapitalType(value);
    }
  },
  mounted() {
    if (this.selectedDropdownCapitalType) {
      this.selected = this.selectedDropdownCapitalType;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/elements/SearchBar/CapitalTypeDropDown.vue